export const environment = {
  production: true

};

export const url = 'https://katamix-work.hu';
//export const url = 'http://localhost:5000';
//export const url = 'http://193.201.188.89:5000';